module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-sm@1x.b062fdd7.png";